
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { ElForm } from 'element-ui/types/form'
import { convertCodeToText, convertTextToCode } from '@/common/area_data'
import { CommonService } from '@/services'
import { cloneDeep, isEqual } from 'lodash'

export const StaffTypes = [
    { key: 1, name: '技术' }
]
let oldValue: any = ''

@Component({
    name: 'recruit-create'
})
export default class extends Vue {
    @Ref('staffForm') private staffEl!: ElForm
    private staffId = ''
    private isLoading = true
    private staffTypes = StaffTypes
    private times = { created_at: '', updated_at: '' }
    private staff: any = {
        name: '',
        type: '',
        region: '',
        duty: '',
        require: ''
    }
    private rules = {
        name: { required: true, message: '请输入职位名', trigger: 'blur' },
        type: { required: true, message: '请选择职位类型', trigger: 'blur' },
        region: { required: true, message: '请选择工作地点', trigger: 'blur' }
    }

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }

    private created() {
        const { id } = this.$route.params
        this.staffId = id
    }

    private async mounted() {
        this.isLoading = true
        await AppModule.getRegion()
        await this.fetchStaff()
        this.isLoading = false
    }

    private async fetchStaff() {
        const params = { id: +this.staffId }
        const result = await CommonService.getStaffDetail(params)
        if (result.status === 200) {
            const { province, city, duty, require } = result.data
            this.times.created_at = result.data.created_at
            this.times.updated_at = result.data.updated_at
            Reflect.deleteProperty(result.data, 'created_at')
            Reflect.deleteProperty(result.data, 'updated_at')
            Reflect.deleteProperty(result.data, 'id')
            oldValue = cloneDeep(result.data)
            const region = convertTextToCode([province, city])
            Object.assign(this.staff, {
                name: result.data.name,
                type: result.data.type,
                region,
                duty,
                require
            })
        }
    }

    private onSelectRegion(value: any) {
        this.staff.region = value
    }

    private onUpdate() {
        this.staffEl.validate(valid => {
            if (!valid) return
            const region = convertCodeToText(this.staff.region).split(',')
            const params = {
                name: this.staff.name,
                type: this.staff.type,
                province: region[0],
                city: region[1] || '市辖区',
                duty: this.staff.duty,
                require: this.staff.require
            }
            if (isEqual(params, oldValue)) {
                this.$message({
                    type: 'warning',
                    message: '请先做出修改',
                    showClose: true
                })
                return
            }
            this.update(params)
        })
    }

    private async update(params: any) {
        this.isLoading = true
        params = { id: this.staffId, ...params }
        const result = await CommonService.updateStaff(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '更新成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })

    }
}
